module.exports = __webpack_public_path__ + "static/vv_dd2-96d956b6bee1460ece4bb80869152a10.png";